import { RuleSearchCategoryContainer } from './RuleSearchCategoryContainer';
export default RuleSearchCategoryContainer;
